import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "./App.css";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ResetPassword from "./pages/ResetPassword";
import ResetPasswordConfirm from "./pages/ResetPasswordConfirm";
import { CartProvider } from "./contexts/CartContext";
import AdminRoutes from "./admin/AdminRoutes";
import Terms from "./pages/Terms";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <CartProvider>
      <main
        id="main-content"
        className="flex-grow-1"
        style={{ paddingTop: "70px" }}
      >
        <Routes>
          {/* public routes */}
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/terms" element={<Terms />} />
          <Route
            path="/reset-password/confirm"
            element={<ResetPasswordConfirm />}
          />

          <Route
            path="/admin/*"
            element={
              // <ProtectedRoute>
              <AdminRoutes />
              // </ProtectedRoute>
            }
          />
        </Routes>
      </main>
    </CartProvider>
  );
}

export default App;
